import { unzipSync } from 'fflate';

export interface ZipEntry {
  name: string;
  data: Uint8Array;
}

export function decompressZip(zipData: Uint8Array): Map<string, Uint8Array> {
  const result = new Map<string, Uint8Array>();

  try {
    const unzipped = unzipSync(zipData);

    for (const [filename, fileData] of Object.entries(unzipped)) {
      if (fileData) {
        result.set(filename, fileData);
      }
    }
  } catch (error) {
    console.error(`[ZIP] Error parsing ZIP:`, error);
    throw error;
  }

  return result;
}
